import React from 'react';
import './styles.css';
import {appText} from '../../assets/text/appText';
import UploadVideoButton from '../Inputs/UploadVideoButton';
import {libraryEmptyState} from '../../assets/images';

interface Props {
  onFilesUpload?: (files: File[]) => void;
  isLoading?: boolean;
  type?: number;
}

const LibraryEmptyState = React.memo(
  ({onFilesUpload, isLoading, type}: Props) => {
    return (
      <div className="LibraryEmptyStateContainer">
        <img src={libraryEmptyState} />
        <p className="Title">{appText.noLibraryTitle}</p>
        <p className="Title">{appText.noLibrarySubtitle}</p>
        {onFilesUpload && (
          <UploadVideoButton
            onVideoSelected={file => onFilesUpload([file])}
            onFilesSelected={onFilesUpload}
            multiple
            isLoading={isLoading}
            type={type}
          />
        )}
      </div>
    );
  },
);

export default LibraryEmptyState;
